import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import { Delete } from '@common/components/Icons';
import { IconButton } from '@common/components/IconButton';

export const DeleteIcon = styled(Delete)`
  fill: ${getThemeColor('bluegrey.60')};
`;

export const StyledDeleteButton = styled(IconButton).attrs({
  type: 'button',
})`
  box-shadow: none;
  background-color: ${getThemeColor('bluegrey.92')};

  &:hover,
  &:focus {
    background-color: ${getThemeColor('bluegrey.92')};
  }
`;
